import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-出入库",
  "use": "icon-出入库-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-出入库\"><path d=\"M192.4 64.6h639.3c33.9 0 66.4 13.5 90.4 37.4 24 24 37.5 56.5 37.5 90.4v639.2c0 33.9-13.5 66.4-37.5 90.4s-56.5 37.5-90.4 37.5H192.4c-33.9 0-66.4-13.5-90.4-37.5s-37.4-56.5-37.4-90.4V192.4c0-33.9 13.5-66.4 37.4-90.4s56.4-37.4 90.4-37.4z m444 799l195.2-143.8-195.2-143.9v82.5h-444v124h444.1v81.2z m195.2-464.7v-124h-444v-82.6L192.4 336.2 387.6 480v-81.1h444z m0 0\" p-id=\"32734\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol